import React, { useEffect, useRef, useState } from "react";
import { Card, Row, Col } from "react-bootstrap";
import { convertToTimeString } from "../utils/utils";
//import { Link } from "react-router-dom";
import "./candidateExamIntro.page.scss";
import Navbar from "../components/Navbar/Navbar";
import Button from "react-bootstrap/Button";
import { useHistory } from "react-router-dom";
import Footer from "../components/Footer/Footer";
import Scrollbar from "../components/scrollbar/scrollbar";
import QuestionButton from "../components/questionButton/questionButton";
import { useSelector } from "react-redux";

function CandidateExamPageIntro() {
  const noOfQuestions = useSelector((state) => state.questions.noOfQuestions);
  const examInstructions = useSelector(
    (state) => state.examDetail.details.instructions
  );
  const examDuration = useSelector(
    (state) => state.examDetail.details.duration
  );
  const examId = useSelector((state) => state.examDetail.details._id);

  const [isLoading, setLoading] = useState(true);
  const loadingInterval = useRef();
  const [increment, setIncrement] = useState(0);
  let history = useHistory();
  const handleClick = () => {
    setLoading(false);
    history.push(`/Exam/${examId}`);
  };

  let draftOut;
  if (noOfQuestions > 60) {
    draftOut = Math.floor((40 / 100) * noOfQuestions);
  } else {
    draftOut = noOfQuestions;
  }

  useEffect(() => {
    if (increment === 0) {
      loadingInterval.current = setInterval(() => {
        setIncrement((val) => 2 + val);
      }, 100);
    }
    if (increment === 100) {
      setLoading(false);
      clearInterval(loadingInterval.current);
    }
  }, [increment]);

  return (
    <div className="bg-Exam-body min-vh-100">
      <Navbar />
      <div className="py-4 mx-2 mx-md-3 mx-lg-5">
        <Card className="border-0">
          <Card.Body className="mb-5 pb-5">
            <div className="w-50 py-3">
              <Card.Title className="instruction-title">
                {" "}
                Please Read All Instructions Carefully Before You Proceed
              </Card.Title>
              <h6>Goodluck!</h6>
            </div>

            <div className="pb-4 pt-2">
              <h5 className="bolder"> {convertToTimeString(examDuration)}</h5>
            </div>

            <Row>
              <Col xs={5}>
                <div className="d-flex flex-wrap w-75">
                  {[...Array(draftOut).keys()].map((i) => (
                    <QuestionButton key={i} variant="viewed" number={i + 1} />
                  ))}
                  {noOfQuestions > 60 && (
                    <>
                      <QuestionButton variant="viewed" number={"..."} />
                      <QuestionButton variant="viewed" number={noOfQuestions} />
                    </>
                  )}
                  {/* {allQuestions.map((item, index) => (
                    <QuestionButton
                      variant="viewed"
                      key={index}
                      number={`${index + 1}`}
                    />
                  ))} */}
                </div>
              </Col>
              <Col xs={7}>
                <div className="alert alert-success border border-success">
                  <Scrollbar style={{ maxHeight: 230 }}>
                    <div className="pe-3">
                      <h3 className="green-card-title">INSTRUCTION</h3>

                      <Card.Text
                        className="green-card-text"
                        dangerouslySetInnerHTML={{ __html: examInstructions }}
                      ></Card.Text>
                      <hr></hr>

                      <Button
                        type="submit"
                        variant="success"
                        disabled={isLoading}
                        onClick={!isLoading ? handleClick : null}
                      >
                        Proceed
                      </Button>
                    </div>
                  </Scrollbar>
                </div>

                <div className="progress-box ms-auto ">
                  <div className="d-flex justify-content-between">
                    <p className="text-info">please wait ...</p>
                    <p className="text-info"> {increment}% </p>
                  </div>
                  <div className="progress">
                    <div
                      style={{ width: `${increment}%` }}
                      className="bg-success"
                    ></div>
                  </div>
                </div>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        <Footer />
      </div>
    </div>
  );
}

export default CandidateExamPageIntro;
